import React from 'react';
import { Link } from 'react-router-dom';

interface ResetLinkProps {
  linkText: string;
}

const ResetLink = ({ linkText }: ResetLinkProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  //   console.log();
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <div className="auth-form__meta d-flex mt-4">
        <Link to="/forgot-password" className="mx-auto">
          {linkText}
        </Link>
      </div>
    </>
  );
};

export default ResetLink;
